import { show, hide } from '@shared/easyfy.utils';

export function setMyPagesMenuState(showLogin: boolean): void {
  const myPagesMenu = document.querySelector<HTMLElement>('#top-menu-mypages');

  if (showLogin) {
    const loginNode =
      myPagesMenu?.querySelector<HTMLElement>('.nav-node-login');
    const nav = myPagesMenu?.querySelector<HTMLElement>('.my-pages-navigation');
    if (loginNode) {
      show(loginNode);
    }
    if (nav) {
      hide(nav);
    }
  } else {
    hide('.nav-node-login');
    hide('.nav-node-bankid-login');
    const favouriteIcon = myPagesMenu?.querySelector<HTMLElement>(
      '.nav-favourite-icon'
    );
    if (favouriteIcon) {
      favouriteIcon.style.display = 'inline-flex';
    }
  }
}
